export const en = {
    "agent-fallback-title": "External Agent",

    "side-menu-basic": "Basics",
    "side-menu-mcp-server": "MCP Server",
    "side-menu-tools-resources": "MCP Tools and Resources",

    "version-draft": "Draft",
    "version-published": "Published version",

    "field-name": "Name",
    "field-name-placeholder": "Name the user will see",

    "field-logo": "Logo",

    "field-title": "Localized name",
    "field-title-description": "Localized name shown to the user.",

    "field-short-description": "Short description",
    "field-short-description-description": "Localized blurb shown to the user under the agent.",

    "field-prompt": "Additional prompt",
    "field-prompt-description": "Optional extra instructions injected into the agent prompt. One value per locale.",

    "field-mcp-endpoint": "Endpoint URL",
    "field-mcp-endpoint-placeholder": "https://mcp.example.com/sse",
    "field-mcp-server-type": "Transport",
    "field-mcp-auth-type": "Authorization",
    "field-mcp-auth-none": "None",
    "field-mcp-auth-api-key": "API key",
    "field-mcp-api-key": "API key",
    "field-mcp-api-key-placeholder": "Token sent in X-Api-Key header",
    "field-mcp-use-zora": "Gozora tunnel",
    "field-mcp-use-zora-description": "Route MCP requests through Gozora.",
    "field-mcp-use-zora-label": "Use Gozora",

    "field-auth-required": "User authorization",
    "field-auth-required-label": "Requires user authorization",
    "field-auth-required-description": "To create an OAuth-app, go to the \"Account linking\" tab.",
    "side-menu-account-linking": "Account linking",

    "account-linking-help": "Configure the OAuth provider Alice will use to authorize the user before the first tool call.",
    "account-linking-field-name": "OAuth-app name",
    "account-linking-field-client-id": "Client ID",
    "account-linking-field-client-secret": "Client secret",
    "account-linking-field-client-secret-keep": "Leave empty to keep the previous value.",
    "account-linking-field-authorization-url": "Authorization URL",
    "account-linking-field-token-url": "Token URL",
    "account-linking-field-refresh-token-url": "Refresh token URL",
    "account-linking-field-scope": "Scope",
    "account-linking-detach": "Remove link",

    "mcp-verified": "Verified",
    "mcp-not-verified": "Not verified",

    "action-check-connection": "Check connection",
    "action-fill-from-mcp": "Fill from MCP",
    "action-save": "Save",
    "action-publish": "Publish",
    "action-add-tool": "Add tool",
    "action-add-resource": "Add resource",
    "action-remove": "Remove",
    "action-retry-processing": "Retry processing",

    "mcp-connection-success": "Connected: {tools} tools, {resources} resources",
    "mcp-connection-error": "Connection failed",
    "mcp-fill-warning-title": "Fill tools and resources from MCP server?",
    "mcp-fill-warning-body": "All current tools and resources, including any manual edits, will be overwritten by data fetched from the MCP server. This cannot be undone.",
    "mcp-fill-confirm": "Overwrite",
    "mcp-fill-cancel": "Cancel",

    "mcp-locked-until-check": "Fill in the MCP server settings and check the connection to enable tools and resources.",

    "processing-banner-title": "Processing widget resources",
    "processing-banner-body": "Usually finishes within a minute. The form is locked until the worker completes.",
    "failed-banner-title": "Resource processing failed",
    "failed-banner-body-with-error": "Last error: {error}. Click retry to try again.",
    "failed-banner-body": "Click retry to try again.",

    "section-mcp-tools-resources-title": "MCP Tools and Resources",
    "subsection-tools-title": "Tools",
    "subsection-resources-title": "Resources",
    "section-tools-empty": "No tools yet. Use \"Fill from MCP\" to import from your MCP server, or add one manually.",
    "section-resources-empty": "No resources yet. Use \"Fill from MCP\" to import from your MCP server, or add one manually.",
    "fill-from-mcp-description": "Pull the current tool and resource list from the verified MCP server. This overwrites whatever is below.",

    "tool-field-name": "Name",
    "tool-field-title": "Title",
    "tool-field-description": "Description",
    "tool-field-input-schema": "Input schema (JSON)",
    "tool-field-visibility": "Visibility",
    "tool-field-output-template": "Output template",
    "tool-field-output-template-none": "None",
    "tool-field-invocation-invoking": "Invocation message (in progress)",
    "tool-field-invocation-invoked": "Invocation message (done)",
    "tool-field-read-only-hint": "Read-only",
    "tool-field-destructive-hint": "Destructive",
    "tool-field-idempotent-hint": "Idempotent",
    "tool-field-open-world-hint": "Open world",

    "resource-field-uri": "Source URI",
    "resource-field-internal-uri": "Internal URI (filled by the worker)",
    "resource-field-mime-type": "MIME type",
    "resource-field-name": "Name",
    "resource-field-description": "Description",
    "resource-meta-prefers-border": "Border",
    "resource-meta-prefers-border-label": "Render with a border around the widget",
    "resource-meta-domain": "Widget domain",
    "resource-meta-domain-placeholder": "yandex.ru",
    "resource-meta-csp-connect": "CSP connect domains",
    "resource-meta-csp-resource": "CSP resource domains",
    "resource-meta-csp-add": "Add domain",
    "resource-meta-preferred-size": "Preferred size (px)",
    "resource-meta-min-width": "Min width",
    "resource-meta-max-width": "Max width",
    "resource-meta-min-height": "Min height",
    "resource-meta-max-height": "Max height",
    "resource-status-pending": "Awaiting processing",
    "resource-status-processed": "Processed",
    "resource-status-failed": "Processing failed",

    "visibility-public": "Public",
    "visibility-widget-only": "Widget-only",
    "visibility-hidden": "Hidden",

    "field-chat-testing": "Testing",
    "field-chat-testing-label": "Available for testing",
    "field-chat-testing-disabled-processing": "Fill in the agent and wait for all resources to be processed.",

    "toast-saved": "Saved",
    "toast-save-error": "Failed to save",
    "toast-load-error": "Failed to load the agent",
    "toast-published": "Published",
    "toast-publish-error": "Failed to publish",
    "toast-mcp-check-error": "MCP probe failed",

    "validation-required": "Required field",
    "validation-url": "Must be a valid URL",
    "validation-tool-name-duplicate": "Duplicate tool name",
    "validation-resource-uri-duplicate": "Duplicate resource URI",
    "validation-invalid-json": "Must be valid JSON or empty"
} as const;

export const ru = {
    "agent-fallback-title": "Внешний агент",

    "side-menu-basic": "Основные",
    "side-menu-mcp-server": "MCP-сервер",
    "side-menu-tools-resources": "MCP Инструменты и ресурсы",

    "version-draft": "Черновик",
    "version-published": "Опубликованная версия",

    "field-name": "Название",
    "field-name-placeholder": "Имя агента, которое увидит пользователь",

    "field-logo": "Логотип",

    "field-title": "Локализованное название",
    "field-title-description": "Локализованное название, которое увидит пользователь.",

    "field-short-description": "Короткое описание",
    "field-short-description-description": "Локализованное описание, которое увидит пользователь под агентом.",

    "field-prompt": "Дополнительный промпт",
    "field-prompt-description": "Необязательные доп. инструкции, добавляемые к промпту агента. Одно значение на локаль.",

    "field-mcp-endpoint": "URL подключения",
    "field-mcp-endpoint-placeholder": "https://mcp.example.com/sse",
    "field-mcp-server-type": "Транспорт",
    "field-mcp-auth-type": "Авторизация",
    "field-mcp-auth-none": "Без авторизации",
    "field-mcp-auth-api-key": "API-ключ",
    "field-mcp-api-key": "API-ключ",
    "field-mcp-api-key-placeholder": "Токен, отправляемый в заголовке X-Api-Key",
    "field-mcp-use-zora": "Туннель Gozora",
    "field-mcp-use-zora-description": "Маршрутизировать MCP-запросы через Gozora.",
    "field-mcp-use-zora-label": "Использовать Gozora",

    "field-auth-required": "Авторизация пользователей",
    "field-auth-required-label": "Требуется авторизация пользователей",
    "field-auth-required-description": "Для создания oauth-приложения перейдите во вкладку «Связка аккаунтов».",
    "side-menu-account-linking": "Связка аккаунтов",

    "account-linking-help": "Настройте OAuth-провайдер, через который Алиса будет авторизовать пользователя перед первым вызовом инструмента.",
    "account-linking-field-name": "Название OAuth-приложения",
    "account-linking-field-client-id": "Client ID",
    "account-linking-field-client-secret": "Client secret",
    "account-linking-field-client-secret-keep": "Оставьте пустым, чтобы сохранить предыдущее значение.",
    "account-linking-field-authorization-url": "URL авторизации",
    "account-linking-field-token-url": "URL получения токена",
    "account-linking-field-refresh-token-url": "URL обновления токена",
    "account-linking-field-scope": "Scope",
    "account-linking-detach": "Удалить связь",

    "mcp-verified": "Проверено",
    "mcp-not-verified": "Не проверено",

    "action-check-connection": "Проверить подключение",
    "action-fill-from-mcp": "Заполнить из MCP",
    "action-save": "Сохранить",
    "action-publish": "Опубликовать",
    "action-add-tool": "Добавить инструмент",
    "action-add-resource": "Добавить ресурс",
    "action-remove": "Удалить",
    "action-retry-processing": "Повторить",

    "mcp-connection-success": "Подключение успешно: {tools} тулов, {resources} ресурсов",
    "mcp-connection-error": "Не удалось подключиться",
    "mcp-fill-warning-title": "Заполнить тулы и ресурсы из MCP-сервера?",
    "mcp-fill-warning-body": "Все текущие тулы и ресурсы, включая ручные правки, будут перезатёрты данными с MCP-сервера. Это действие нельзя отменить.",
    "mcp-fill-confirm": "Перезаписать",
    "mcp-fill-cancel": "Отмена",

    "mcp-locked-until-check": "Заполните настройки MCP-сервера и нажмите «Проверить подключение», чтобы разблокировать тулы и ресурсы.",

    "processing-banner-title": "Обработка ресурсов виджетов",
    "processing-banner-body": "Обычно занимает до минуты. На это время форма заблокирована.",
    "failed-banner-title": "Ошибка обработки ресурсов",
    "failed-banner-body-with-error": "Последняя ошибка: {error}. Нажмите «Повторить», чтобы запустить ещё раз.",
    "failed-banner-body": "Нажмите «Повторить», чтобы запустить ещё раз.",

    "section-mcp-tools-resources-title": "MCP Инструменты и ресурсы",
    "subsection-tools-title": "Инструменты",
    "subsection-resources-title": "Ресурсы",
    "section-tools-empty": "Инструментов пока нет. Нажмите «Заполнить из MCP», чтобы импортировать с MCP-сервера, или добавьте вручную.",
    "section-resources-empty": "Ресурсов пока нет. Нажмите «Заполнить из MCP», чтобы импортировать с MCP-сервера, или добавьте вручную.",
    "fill-from-mcp-description": "Загрузите актуальный список инструментов и ресурсов с проверенного MCP-сервера. Текущее содержимое ниже будет заменено.",

    "tool-field-name": "Имя",
    "tool-field-title": "Заголовок",
    "tool-field-description": "Описание",
    "tool-field-input-schema": "Схема входных данных (JSON)",
    "tool-field-visibility": "Видимость",
    "tool-field-output-template": "Шаблон виджета",
    "tool-field-output-template-none": "Не задан",
    "tool-field-invocation-invoking": "Сообщение при запуске",
    "tool-field-invocation-invoked": "Сообщение по завершении",
    "tool-field-read-only-hint": "Read-only",
    "tool-field-destructive-hint": "Деструктивный",
    "tool-field-idempotent-hint": "Идемпотентный",
    "tool-field-open-world-hint": "Open world",

    "resource-field-uri": "Исходный URI",
    "resource-field-internal-uri": "Внутренний URI (заполняется воркером)",
    "resource-field-mime-type": "MIME-тип",
    "resource-field-name": "Название",
    "resource-field-description": "Описание",
    "resource-meta-prefers-border": "Рамка",
    "resource-meta-prefers-border-label": "Отображать виджет с рамкой",
    "resource-meta-domain": "Домен виджета",
    "resource-meta-domain-placeholder": "yandex.ru",
    "resource-meta-csp-connect": "CSP connect-домены",
    "resource-meta-csp-resource": "CSP resource-домены",
    "resource-meta-csp-add": "Добавить домен",
    "resource-meta-preferred-size": "Желаемый размер (px)",
    "resource-meta-min-width": "Минимальная ширина",
    "resource-meta-max-width": "Максимальная ширина",
    "resource-meta-min-height": "Минимальная высота",
    "resource-meta-max-height": "Максимальная высота",
    "resource-status-pending": "Ожидает обработки",
    "resource-status-processed": "Обработан",
    "resource-status-failed": "Ошибка обработки",

    "visibility-public": "Видимый",
    "visibility-widget-only": "Только в виджете",
    "visibility-hidden": "Скрытый",

    "field-chat-testing": "Тестирование",
    "field-chat-testing-label": "Доступен для тестирования",
    "field-chat-testing-disabled-processing": "Заполните агента и дождитесь обработки всех ресурсов.",

    "toast-saved": "Сохранено",
    "toast-save-error": "Не удалось сохранить",
    "toast-load-error": "Не удалось загрузить агента",
    "toast-published": "Опубликовано",
    "toast-publish-error": "Не удалось опубликовать",
    "toast-mcp-check-error": "Не удалось подключиться к MCP",

    "validation-required": "Обязательное поле",
    "validation-url": "Введите корректный URL",
    "validation-tool-name-duplicate": "Имя инструмента не уникально",
    "validation-resource-uri-duplicate": "URI ресурса не уникален",
    "validation-invalid-json": "Введите корректный JSON или оставьте пустым"
} as const;
